import { Button, Cascader, Form, Input, Modal, Select, Upload } from 'antd';
import React, { type FC, useEffect } from 'react';

import useUser from '@/lib/hooks/useUser';

import { feedbackToFormValues, getHandleFinish } from './helpers';
import type { FeedbackEditModalProps, FeedbackForm } from './types';

const { Item, useForm } = Form;

const FeedbackEditModal: FC<FeedbackEditModalProps> = ({
  editingFeedback,
  open,
  onClose,
  update,
  householdNumberOptions,
  typeOptions,
}) => {
  const { data: user } = useUser();

  const [form] = useForm<FeedbackForm>();

  useEffect(() => {
    const handleReset = () => {
      if (!open) {
        return form.resetFields();
      }
      if (editingFeedback) {
        const values = feedbackToFormValues(editingFeedback);
        return form.setFieldsValue(values);
      }
    };
    handleReset();
  }, [editingFeedback, form, open]);

  const handleFinish = getHandleFinish(editingFeedback, user);

  return (
    <Modal
      open={open}
      onCancel={onClose}
      onOk={form.submit}
      title={editingFeedback ? '新增意見反應' : '編輯意見反應'}
    >
      <Form
        form={form}
        layout="vertical"
        onFinish={async (values) => {
          await handleFinish(values);
          update();
          onClose();
        }}
      >
        <Item
          label="戶號"
          name="householdNumber"
          required
          rules={[{ required: true, message: '請選擇戶號' }]}
        >
          <Cascader options={householdNumberOptions} placeholder="請選擇戶號" />
        </Item>
        <Item
          label="類別"
          name="type"
          required
          rules={[{ required: true, message: '請選擇類別' }]}
        >
          <Select options={typeOptions} placeholder="請選擇類別" />
        </Item>
        <Item
          label="標題"
          name="title"
          required
          rules={[{ required: true, message: '請輸入標題' }]}
        >
          <Input placeholder="請輸入標題" />
        </Item>
        <Item
          label="內容"
          name="content"
          required
          rules={[{ required: true, message: '請輸入內容' }]}
        >
          <Input.TextArea placeholder="請輸入內容" showCount maxLength={100} />
        </Item>
        <Item
          label="圖片"
          name="image"
          valuePropName="fileList"
          getValueFromEvent={(e) => {
            if (Array.isArray(e)) {
              return e;
            }
            return e && e.fileList;
          }}
        >
          <Upload
            beforeUpload={() => false}
            accept="image/*"
            multiple={false}
            listType="picture"
            maxCount={1}
          >
            <Button>上傳圖片</Button>
          </Upload>
        </Item>
      </Form>
    </Modal>
  );
};

export default FeedbackEditModal;
